// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"az_izc","legal":"az_jzc"};